import { ProductCatalogAttributeSelectionType } from '@graphql/generated';
import { CatalogProductListFilters } from '../Catalog.types';

const FIRST_BRAND_CODE = 'brand';

/**
 * Sorts filters by brand, price, and then alphabetically
 * @param filters CatalogProductListFilters
 * @returns CatalogProductListFilters
 */
export const sortFilters = (filters: CatalogProductListFilters) => {
  return filters.sort((a, b) => {
    /**
     * If a is the brand filter, it should always be first
     */
    if (a.attributeGroup.code === FIRST_BRAND_CODE) return -1;
    /**
     * If a is the price filter, it should always be second (after brand)
     */
    if (a.attributeGroup.filterSelectionType === ProductCatalogAttributeSelectionType.priceRange && b.attributeGroup.code !== FIRST_BRAND_CODE) return -1;
    /**
     * The rest of the filters should be sorted alphabetically
     */
    return a.attributeGroup.title.localeCompare(b.attributeGroup.title);
  });
};
